/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';

/* state shape */

// use action constants as flags for when the api call is being made and finishes
let loading = {};
Object.keys(constants).map((constant) => {
    loading[constant] = false;
});

let firstLoad = {},
    hasNoData = {};

Object.keys(constants).map((constant) => {
    if (constant.match("GET") || constant.match("LIST") || ['APP_READY', 'APP_LOADING', 'CURATION_ID', 'SUB_FETCH_EXPIRED_PLAN'].indexOf(constant) !== -1) {
        firstLoad[constant] = false;
        hasNoData[constant] = false;
    }
});

export const defaultState = {
    bootstrap: {
        configLoaded: false,
        isClient: false
    },
    app: {
        userSessionActive: true,
        configLoaded: false,
        userLoaded: false,
        userPermsLoaded: false,
        firstLoad,
        loading,
        hasNoData,
        config: {},
        flags: {
            bannerSuppressed: false,
            bannerVisible: true,
            localStorageNotice: false,
            marketing: true,
            routeViewType: 1,
        },
        statuses: {
            socialsDisconnected: 0,
            login: {
                nextLocation: '',
                statusCode: '',
                statusMsg: ''
            }
        },
        errors: {
            api: [],
            local: []
        },
        messages: [],
        triggeredErrors: {
            socialMove: false,
        }
    },
    user: {
        detail: {
            id: 0,
            name: '',
            mailOpts: 0,
            organization: '',
            defaultSaId: 0,
            defaultPdId: 0,
            email: '',
            emailHash: '',
            emailActive: '',
            routeViewType: 1,
            bounceCount: 0,
            options: 0,
            isAgent: false,
            isClient: false,
            pauseButton: 1,
            needsPassword: false,
            timezone: 'America/Los_Angeles',
            apiKeys: '',
            pastDue: 0,
            subscriptionTerm: '',
            trialEligible: false,
            subscriptionState: 0,
            nextRenewal: 0,
            postLimitReset: 0,
            username: '',
            avatar: '',
            pubLevel: 1
        },
        perms: {
            permbits: {},
            perms: {},
            resources: {}
        },
        plan: {
            addOns: [],
            planLevel: 1,
            planTerm: 1,
            details: 0, // link to plans,
            promoRedeemed: false,
            pauseStart: 0,
            pauseEnd: 0
        }
    },
    socialLogins: [],
    socials: {
        sort: {key: 'name', direction: 'ASC'},
        list: [],
        filteredList: [],
        types: [],
        defaults: [],
        counts: {},
        batchCreates: {},
        categories: {},
        playlists: {},
        analyzerData: {}
    },
    // social id -> that social's link page settings, see app/utility/LinkpageSettings.js
    linkpages: {},
    automatedRoutes: {
        sort: {key: 'name', direction: 'ASC'},
        list: [],
        filter: {},
        filteredList: [],
        types: {},
        validInputs: [],
        logs: [],
        socialInputCreds: []
    },
    curation: {
        route: {},
        items: [],
        count: 0,
    },
    posts: {
        created: 0,
        updated: 0,
        preview: null,
        post: null,
        postValidators: {},
        mediaValidation: {},
        mediaGallery: {
            page: 0,
            media: []
        }
    },
    stats: {
        social: {
            id: 0,
            data: {}
        },
        route: {
            id: 0,
            data: {}
        },
        socialPosts: {
            id: 0,
            data: []
        },
        routePosts: {
            id: 0,
            data: []
        },
        geo: {
            data: []
        },
        allStats: {
            data: {}
        },
        allStatsPosts: {
            data: []
        }
    },
    categories: [],
    shorteners: [],
    queue: {
        list: [],
        hasMore: true,
        calendar: {
            list: [],
            detail: []
        }
    },
    everqueue: {
        list: {},
        hasMore: false
    },
    domains: [],
    subaccounts: {
        sort: {key: 'name', direction: 'ASC'},
        list: [],
        filter: {},
        filteredList: []
    },
    notifications: [],
    plans: {
        current: {},
        details: {},
        billingInfo: {},
        invoices: [],
        invoice: '',
        limitCheck: {},
        changePreview: null,
        changePreviewRequest: null,
        updatedPullFreq: 0,
        validatedCoupon: {},
        subscriptionPaused: '',
        expiredPlan: {}
    },
    utilities: {
        timezones: [],
        urlInfo: {},
        countries: [],
        regions: [],
        favorites: [],
        relatedTags: []
    },
    feeds: {
        searchResults: {
            feeds: [],
            tags: []
        },
        validated: []
    },
    postgroups: [],
    bulk: {
        hints: {},
        items: [],
        searchResults: [],
        completedImports: 0,
        token: 0,
        status: null
    },
    modals: {
        stack: []
    },
    connections: []
};
